'use client';

import { useLayoutEffect, useRef } from 'react';
import { useEnterAuth } from '@enter/auth';
import { useMixpanel } from '@/contexts/mixpanel';
import { useCgp } from '@/contexts/cgp';
import { resetClarityIdentity } from '@/contexts/clarity';
import { resetDatadogIdentity } from '@/lib/datadog/consent';
import { gtmClient } from '@/lib/gtm/client';

/** Auth subject 只用来判断账号边界，不把它伪装成业务 user_id 上报。 */
export function AnalyticsIdentitySync() {
    const { isLoading, isAuthenticated, user } = useEnterAuth();
    const subject = isAuthenticated ? user?.sub ?? null : null;
    const previous = useRef<string | null | undefined>(undefined);
    const { resetIdentity: resetMixpanel, confirmAnonymous } = useMixpanel();
    const { resetIdentity: resetCgp, confirmAnonymous: confirmCgpAnonymous } = useCgp();

    useLayoutEffect(() => {
        if (isLoading) return;
        // 首次权威匿名只清 SDK 恢复的登录身份，不重置正常匿名 visitor。
        if (previous.current === undefined && subject === null) {
            for (const confirm of [confirmAnonymous, confirmCgpAnonymous]) {
                try { confirm(); }
                catch { console.warn('[analytics] anonymous confirmation failed'); }
            }
        }
        const changed = previous.current !== undefined && previous.current !== subject;
        previous.current = subject;
        if (!changed) return;
        for (const reset of [resetMixpanel, resetCgp, resetClarityIdentity, resetDatadogIdentity, gtmClient.resetIdentity]) {
            try { reset(); }
            catch { console.warn('[analytics] identity cleanup failed'); }
        }
    }, [isLoading, subject, resetMixpanel, resetCgp, confirmAnonymous, confirmCgpAnonymous]);

    return null;
}
